export const APP_NAME = 'Choose Vehicle';

// The scope is unused for now because it's not configured on bridge yet
export const APP_SCOPE = 'deal-mgmt.choosevehicle.app.access';
export const CLIENT_ID = '0oa175hmkzncH6x27358';
export const NON_PROD_CLIENT_ID = '0oa175hfnhaU3MPEr358';

export const OKTA_CONFIG_ID_PROD = 'cv_prod_bridge_signin_spa_makemydeal';
export const OKTA_CONFIG_ID_NON_PROD = 'cv_nonprod_bridge_signin_spa_makemydeal';
